'use client';

import { ReactNode } from 'react';
import { SxProps, Theme, styled } from '../styles';
import Box, { Props as BoxProps } from '../Box';

type Variant = 'default' | 'narrow' | 'medium';

export interface Props extends BoxProps {
  id?: string;
  dataTestId?: string;
  sx?: SxProps<Theme>;
  children?: ReactNode;
  variant?: Variant;
}

export const getMaxWidth = (variant: Variant) => {
  const maxWidth = {
    default: {
      xs: '100%',
      sm: 704,
      md: 1168,
      lg: 1328,
      xl: 1520,
    },
    narrow: {
      xs: 592,
      md: 800,
      lg: 800,
      xl: 800,
    },
    medium: {
      md: 968,
      lg: 968,
      xl: 968,
    },
  };
  return {
    ...maxWidth.default,
    ...maxWidth[variant],
  };
};

export const ContentWrapperBox = styled(Box, {
  shouldForwardProp: (prop) =>
    !(['dataTestId', 'variant'] as (number | string | Symbol)[]).includes(prop),
})<Props>(({ theme: { spacing, breakpoints }, variant = 'default' }) => {
  const { xs, sm, md, lg, xl } = getMaxWidth(variant);
  return {
    boxSizing: 'border-box',
    position: 'relative',
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: xs,
    [breakpoints.up('sm')]: {
      maxWidth: sm,
      paddingLeft: 0,
      paddingRight: 0,
    },
    [breakpoints.up('md')]: {
      maxWidth: md,
      paddingLeft: spacing(4),
      boxSizing: 'content-box !important',
      paddingRight: spacing(4),
    },
    [breakpoints.up('lg')]: {
      maxWidth: lg,
    },
    [breakpoints.up('xl')]: {
      maxWidth: xl,
    },
  };
});

const ContentWrapper = ({ ...props }: Props) => (
  <ContentWrapperBox data-testid={props.dataTestId} {...props} />
);

export default ContentWrapper;
